const inViewport = ( element ) => {
    const rect = element.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) &&
        rect.right <= ( window.innerWidth || document.documentElement.clientWidth )
    );
}

const loadMore = (btn, content) => {
    if ( btn.classList.contains('is-loading') || btn.classList.contains('disabled') ) {
        return false;
    }

    if( !btn && !content ) {
        return false;
    }

    window.BlogRequest(btn, content);
}



window.addEventListener('scroll', () => {
    const btn = document.getElementById('blog-load-more');
    const content = document.getElementById('blog-load-more-content');

    if( !btn && !content ) {
        return false;
    }

    if ( inViewport(btn) ) {
        loadMore(btn, content);
    }
}, {
    passive: true
})
